export default function createSiteDisplayNameReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_SITE_DISPLAY_NAME_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_SITE_DISPLAY_NAME_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_SITE_DISPLAY_NAME_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}